module.exports = __webpack_public_path__ + "img/desc-2.1.89c1031b.jpg";